<template>
    <main class="main promo">
        <page-preloader
            v-if="diagnosticsStatus === 'loading'"
            :isLoading="true"
        ></page-preloader>
        <div class="container" v-else>
            <div class="row">
                <div class="col-md-3" v-if="filters">
                    <the-filters :filters="filters" moduleName="diagnostics" />
                </div>
                <div class="col-md-9">
                    <div class="c-page-headline">
                        <h1 class="c-page-headline__title">
                            Raport / Stan kas
                        </h1>

                        <div class="c-settings-count" v-if="diagnostics">
                            <span>{{
                                diagnostics.length
                                    | plurals('wynik', 'wyniki', 'wyników')
                            }}</span>
                        </div>
                    </div>
                    <selected-filters
                        class="mb-4"
                        :filters="filters"
                        moduleName="diagnostics"
                    />
                    <div class="content">
                        <div class="c-table reportStatus">
                            <div
                                class="c-thead"
                                v-sticky-elem="{
                                    background: 'var(--color-gray-100)'
                                }"
                            >
                                <div class="c-td is-1">
                                    <span class="title">
                                        ID&nbsp;kasy <br />Nazwa sklepu</span
                                    >
                                </div>
                                <div class="c-td is-10">
                                    <span class="title">
                                        Producent i wersja oprogramowania</span
                                    >
                                </div>
                                <div class="c-tw w-paragons">
                                    <div class="c-td is-2 ">
                                        <span
                                            v-tooltip="tooltips.receipts"
                                            class="d-flex flex-column title align-items-center justify-content-center "
                                        >
                                            Paragony
                                            <a-icon class="icon" icon="Info" />
                                        </span>
                                    </div>
                                    <div class="c-td is-3">
                                        <span class="title">
                                            Ostatni <br />paragon</span
                                        >
                                    </div>
                                    <div class="c-td is-4">
                                        <span
                                            v-tooltip="tooltips.receiptStatus"
                                            class="d-flex  flex-column title align-items-center justify-content-center"
                                        >
                                            Status <br />paragonów
                                            <a-icon class="icon" icon="Info"
                                        /></span>
                                    </div>
                                </div>
                                <div class="c-tw w-connection">
                                    <div class="c-td is-5 ">
                                        <span
                                            v-tooltip="tooltips.promotionUsage"
                                            class="d-flex flex-column title align-items-center justify-content-center"
                                        >
                                            Użycia <br />promocji<a-icon
                                                class="icon"
                                                icon="Info"
                                        /></span>
                                    </div>
                                    <div class="c-td is-6">
                                        <span
                                            v-tooltip="tooltips.usageState"
                                            class="d-flex  flex-column title align-items-center justify-content-center"
                                        >
                                            Status <br />użyć
                                            <a-icon class="icon" icon="Info"
                                        /></span>
                                    </div>
                                </div>
                                <div class="c-tw w-rest">
                                    <div class="c-td is-7">
                                        <span class="title">
                                            Ostatnie <br />połączenie</span
                                        >
                                    </div>
                                    <div class="c-td is-8">
                                        <span
                                            v-tooltip="
                                                tooltips.connectionStatus
                                            "
                                            class="d-flex  flex-column title align-items-center justify-content-center"
                                        >
                                            Status <br />połączeń
                                            <a-icon class="icon" icon="Info"
                                        /></span>
                                    </div>
                                </div>
                            </div>
                            <div class="c-tbody">
                                <device-preview
                                    v-for="(device, idx) in diagnostics"
                                    :key="idx"
                                    :data="device"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import DevicePreview from '@/components/reports/DevicePreview'

export default {
    computed: {
        tooltips() {
            return this.$store.getters.getDiagnosticsTooltips
        },
        companies() {
            return this.$store.getters.getCompaniesForFilters
        },
        diagnostics() {
            const active = this.filters.active.value
            const diagnostics = this.$store.getters.getDiagnostics
            const activeDiagnostics = this.$store.getters.getActiveDiagnostics

            return active ? activeDiagnostics : diagnostics
        },
        filters() {
            return this.$store.getters.getDiagnosticsFilters
        },
        paging() {
            return this.$store.getters.getDiagnosticsPaging
        },
        perPage() {
            return this.paging.perPage
        },
        current() {
            return this.paging.page
        },
        total() {
            return this.paging.totalPages
        },
        diagnosticsStatus() {
            return this.$store.getters.getDiagnosticsStatus
        }
    },

    methods: {
        fetch() {
            this.$store.dispatch('diagnosticsFetch', {
                mode: 'details'
            })
        },
        changeResultsPerPage(value) {
            return this.$router
                .push({
                    query: { ...this.$route.query, show: value, page: 1 }
                })
                .then(() => {
                    this.fetch()
                })
        },
        onChange(page) {
            return this.$router
                .push({
                    query: { ...this.$route.query, page: page }
                })
                .then(() => {
                    this.fetch()
                })
        }
    },

    async created() {
        this.$store.dispatch('devicesFetch')

        await this.fetch()

        this.$store.$storage.setItem(
            'diagnostics',
            JSON.stringify(this.$store.getters.getDiagnosticStatuses)
        )
    },

    components: {
        DevicePreview
    }
}
</script>
